import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin, FiClock } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const handleServiceClick = (hash, e) => {
    e.preventDefault();
    navigate(`/services#${hash}`);
    setTimeout(() => {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <footer className="bg-gray-900 text-white" style={{ backgroundColor: '#333333' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img
              src="https://media.phst.co.za/file/ph/primehost-logo-730-dm-trns.png"
              alt="Primehost"
              className="h-8 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Elevate your business with digital solutions that combine striking design with rock-solid technical performance.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-3 text-sm">
                <SafeIcon icon={FiMapPin} className="w-4 h-4 text-primary-500" />
                <span className="text-gray-300">Waterfall, Midrand, Gauteng</span>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <SafeIcon icon={FiClock} className="w-4 h-4 text-primary-500" />
                <span className="text-gray-300">08:00 - 16:00 Daily</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">About us</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">Services</Link></li>
              <li><Link to="/pricing" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">Pricing</Link></li>
              <li><Link to="/portfolio" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">Portfolio</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={(e) => handleServiceClick('hosting', e)} 
                  className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm text-left"
                >
                  Web hosting
                </button>
              </li>
              <li>
                <button 
                  onClick={(e) => handleServiceClick('email', e)} 
                  className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm text-left"
                >
                  Email hosting
                </button>
              </li>
              <li>
                <button 
                  onClick={(e) => handleServiceClick('design', e)} 
                  className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm text-left"
                >
                  Web design
                </button>
              </li>
              <li>
                <button 
                  onClick={(e) => handleServiceClick('domains', e)} 
                  className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm text-left"
                >
                  Domain registration
                </button>
              </li>
              <li><Link to="/faq" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">FAQ</Link></li>
              <li><Link to="/knowledge" className="text-gray-300 hover:text-primary-500 transition-colors duration-200 text-sm">Knowledge base</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact us</h3>
            <div className="space-y-3">
              <a
                href="tel:+27100070690"
                className="flex items-center space-x-3 text-gray-300 hover:text-primary-500 transition-colors duration-200"
              >
                <SafeIcon icon={FiPhone} className="w-4 h-4" />
                <span className="text-sm">+27 10 007 0690</span>
              </a>
              <a
                href="mailto:support@primehost.co.za"
                className="flex items-center space-x-3 text-gray-300 hover:text-primary-500 transition-colors duration-200"
              >
                <SafeIcon icon={FiMail} className="w-4 h-4" />
                <span className="text-sm">support@primehost.co.za</span>
              </a>
              <div className="pt-2">
                <Link
                  to="/portal"
                  className="inline-block bg-teal-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-teal-800 transition-colors duration-200"
                >
                  Client portal
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Primehost. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link
                to="/privacy"
                className="text-gray-400 hover:text-primary-500 transition-colors duration-200 text-sm"
              >
                Privacy policy
              </Link>
              <Link
                to="/terms"
                className="text-gray-400 hover:text-primary-500 transition-colors duration-200 text-sm"
              >
                Terms of service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;